/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IUserGroupPageOwnProps, IUserGroupPageStateProps, IUserGroupPageDispatchProps, UserGroupPage } from "../../components/userGroup/UserGroupPage";
import { ITypedOption } from "../../models/common/typedOption";
import { getUserGroupPage, UserGroupThunkDispatch } from "source/models/store/userGroup";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IUserGroupPageOwnProps): IUserGroupPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            userGroupPage: null
        };
    }
    const userGroup = applicationState.userGroup;
    return {
        appState: applicationState.session,
        dataId: userGroup.page.dataId,
        userGroupPage: userGroup.page.userGroupPage
    };
}

export function mapDispatchToProps(dispatch: UserGroupThunkDispatch): IUserGroupPageDispatchProps {
    return {
        onGetUserGroupsPage: () => dispatch(getUserGroupPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IUserGroupPageStateProps, IUserGroupPageDispatchProps, IUserGroupPageOwnProps>(mapStateToProps, mapDispatchToProps)(UserGroupPage);